// @flow
import React, { Component, Fragment } from "react";
import Divider from "@material-ui/core/Divider";
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";
import HelpIcon from "@material-ui/icons/Help";
import CopyrightIcon from "@material-ui/icons/Copyright";

import { NavbarMenu, NavbarMenuGroup, NavbarMenuItem } from "imagus-components";
import { NavList, AdminList, DocList, LegalItem } from "./NavList";
import AuthedNavbarMenuItem from "../components/AuthedNavbarMenuItem";
import UserAuth from "../containers/UserAuth";
import Terms from "../../account/components/Terms";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import LogoImage from "../../../images/logo.svg";
import BookSVGIcon from "../../../images/MenuBook.svg";

type MenuStatesType = {
  adminOpen: boolean,
  legalOpen: boolean,
  documentOpen: boolean,
  termsOpen: boolean
};

type MenuPropsType = {
  children: React$Node
};

class Menu extends Component<MenuPropsType, MenuStatesType> {
  constructor(props: MenuPropsType) {
    super(props);
    this.state = {
      adminOpen: false,
      legalOpen: false,
      documentOpen: false,
      termsOpen: false
    };
  }

  handleSubMenuToggle = (menu: string): * => (): * => {
    this.setState({ [menu]: !this.state[menu] });
  };

  render(): React$Element<*> {
    return (
      <UserAuth principal="user" unAuthChildren={<RedirectoLogin />}>
        <NavbarMenu
          children={this.props.children}
          logo={LogoImage}
          title="Vix Vizion"
          menus={
            <Fragment>
              <Terms
                open={this.state.termsOpen}
                handleModalStatus={this.handleSubMenuToggle("termsOpen")}
              />
              {NavList.map(
                (item: *, i: number): * => (
                  <AuthedNavbarMenuItem
                    key={"menu" + i}
                    to={item.to}
                    auth={item.auth}
                    text={item.text}
                    icon={item.icon}
                    onClick={item.onClick}
                  />
                )
              )}
              <Divider />

              <div className="top-margin-50">
                <NavbarMenuGroup
                  open={this.state.adminOpen}
                  subHeader={
                    <AuthedNavbarMenuItem
                      key={"admin-subheader"}
                      auth={["imagus_admin"]}
                      text={"Admin"}
                      icon={<SettingsApplicationsIcon />}
                      onClick={this.handleSubMenuToggle("adminOpen")}
                      isSubHeader
                      open={this.state.adminOpen}
                    />
                  }
                  subLists={AdminList.map(
                    (item: *, i: number): * => (
                      <AuthedNavbarMenuItem
                        key={"admin" + i}
                        to={item.to}
                        auth={item.auth}
                        text={item.text}
                        icon={item.icon}
                        onClick={item.onClick}
                        isNested
                      />
                    )
                  )}
                />
              </div>

              <NavbarMenuGroup
                open={this.state.legalOpen}
                subHeader={
                  <AuthedNavbarMenuItem
                    key={"legal-subheader"}
                    auth={["user"]}
                    text={"Legal"}
                    icon={<CopyrightIcon />}
                    onClick={this.handleSubMenuToggle("legalOpen")}
                    isSubHeader
                    open={this.state.legalOpen}
                  />
                }
                subLists={
                  <AuthedNavbarMenuItem
                    key={"legal-item"}
                    auth={LegalItem.auth}
                    text={LegalItem.text}
                    icon={LegalItem.icon}
                    onClick={this.handleSubMenuToggle("termsOpen")}
                    isNested
                  />
                }
              />

              <NavbarMenuGroup
                open={this.state.documentOpen}
                subHeader={
                  <AuthedNavbarMenuItem
                    key={"document-subheader"}
                    auth={["user"]}
                    text={"Document"}
                    icon={<img
                      src={BookSVGIcon}
                      style={{
                        width: "1em",
                        height: "1em",
                        display: "inline-block",
                        fontSize: "24px",
                        transition: "fill 200ms",
                        userSelect: "none",
                        flexShrink: 0
                      }}
                    />}

                    onClick={this.handleSubMenuToggle("documentOpen")}
                    isSubHeader
                    open={this.state.documentOpen}
                  />
                }
                subLists={DocList.map(
                  (item: *, i: number): * => (
                    <AuthedNavbarMenuItem
                      key={"document" + i}
                      to={item.to}
                      auth={item.auth}
                      text={item.text}
                      icon={item.icon}
                      onClick={item.onClick}
                      isNested
                    />
                  )
                )}
              />
              <Divider />
              <div style={{ pointerEvents: "none" }}>
                <NavbarMenuItem text={`v ${process.env.REACT_APP_PACKAGE_VERSION}`} />
              </div>
            </Fragment>
          }
        />
      </UserAuth>
    );
  }
}

export default Menu;
